import { ApiService } from 'services';
import { toastr } from 'react-redux-toastr';

import { handleException } from 'actions/exceptions';

export const EDIT_ACCOUNT_CP_EQUITY_INTEREST = 'EDIT_ACCOUNT_CP_EQUITY_INTEREST';
export const EDIT_ACCOUNT_CP_EQUITY_INTEREST_CANCEL = 'EDIT_ACCOUNT_CP_EQUITY_INTEREST_CANCEL';
export const UPDATE_ACCOUNT_CP_EQUITY_INTEREST_REQUEST = 'UPDATE_ACCOUNT_CP_EQUITY_INTEREST_REQUEST';
export const UPDATE_ACCOUNT_CP_EQUITY_INTEREST_SUCCESS = 'UPDATE_ACCOUNT_CP_EQUITY_INTEREST_SUCCESS';
export const UPDATE_ACCOUNT_CP_EQUITY_INTEREST_ERROR = 'UPDATE_ACCOUNT_CP_EQUITY_INTEREST_ERROR';

function edit() {
  return {
    type: EDIT_ACCOUNT_CP_EQUITY_INTEREST
  };
}

function cancelEdit() {
  return {
    type: EDIT_ACCOUNT_CP_EQUITY_INTEREST_CANCEL
  };
}

function request() {
  return {
    type: UPDATE_ACCOUNT_CP_EQUITY_INTEREST_REQUEST
  };
}

function receive(cpEquityInterest) {
  return {
    type: UPDATE_ACCOUNT_CP_EQUITY_INTEREST_SUCCESS,
    cpEquityInterest
  };
}

function reject() {
  return {
    type: UPDATE_ACCOUNT_CP_EQUITY_INTEREST_ERROR
  };
}

export function editAccountCpEquityInterest() {
  return (dispatch) => {
    dispatch(edit());
  };
}

export function cancelEditAccountCpEquityInterest() {
  return (dispatch) => {
    dispatch(cancelEdit());
  };
}

export function updateAccountCpEquityInterest(accountId, accountCpEquityInterest) {
  const value = accountCpEquityInterest === 'true';
  const formData = new FormData();
  formData.append('cpEquityInterest', value);

  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .updateAccountCpEquityInterest(accountId, formData)
      .then(() => {
        dispatch(receive(value));
        toastr.success('Success', 'Account controlling person equity interest updated successfully');
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
